import React from 'react';
import Sortable from 'library/structures/sortable';
import styled from 'styled-components';

const StyledStepRows = styled.div`
  padding: 1em 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 3em;
  max-height: ${(props) => props.maxHeight || '100%'};
  overflow-y: auto;
`;

const StyledSortableRow = styled.div`
  display: flex;
  align-items: center;
`;

const StyledHandle = styled.div`
  padding: 0.5em;
  cursor: move;
`;

class SectionSortable extends Sortable {
  constructor(...params) {
    super(...params);
  }

  renderControls = (name, i, disabled) =>
    !disabled ? (
      <StyledHandle onMouseDown={this._startDrag.bind(this, i)}>=</StyledHandle>
    ) : null;

  mapChildren = (child, i) => {
    const { ...props } = child.props;
    if (child.key === 'placeholder') {
      return React.cloneElement(child, { ...props, ref: this.placeholderRef });
    }

    return (
      <StyledSortableRow
        data-index={i}
        data-sortable={!child.props.disabled}
        key={child.key}
      >
        {this.renderControls(child.type.name, i, child.props.disabled)}
        {React.cloneElement(child, props)}
      </StyledSortableRow>
    );
  };

  render() {
    const { children, ...props } = this.props;
    const { dragging, placeholder, currentDragIndex } = this.state;

    const ComputedChildren = (this.state.dragging
      ? this.state.children
      : React.Children.toArray(children)
    ).filter(({ key }) => key !== 'placeholder');

    if (placeholder) {
      ComputedChildren.splice(currentDragIndex, 0, placeholder);
    }

    return (
      <StyledStepRows ref={this.parentRef} dragging={dragging} {...props}>
        {ComputedChildren.map(this.mapChildren)}
      </StyledStepRows>
    );
  }
}

export default SectionSortable;
